export default "__VITE_ASSET__BdKDSjaX__"